// features/course/courseSlice.js

import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import courseService from "./courseService";

// Async actions
export const getCourses = createAsyncThunk("course/get-courses", async (_, thunkAPI) => {
  try {
    return await courseService.getCourses();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

 

export const createCourses = createAsyncThunk(
  "course/create-course",
  async (courseData, thunkAPI) => {
    try {
      return await courseService.createCourse(courseData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const getACourse = createAsyncThunk("course/get-course", async (id, thunkAPI) => {
  try {
    return await courseService.getCourse(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateACourse = createAsyncThunk("course/update-course", async (data, thunkAPI) => {
  try {
    return await courseService.updateCourse(data);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const deleteACourse = createAsyncThunk("course/delete-course", async (id, thunkAPI) => {
  try {
    return await courseService.deleteCourse(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const resetState = createAction("Reset_all");

const initialState = {
  courses: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};

export const courseSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCourses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCourses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.courses = action.payload;
      })
      .addCase(getCourses.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(createCourses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCourses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdCourse = action.payload;
      })
      .addCase(createCourses.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(getACourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getACourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.courseData = action.payload;
      })
      .addCase(getACourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(updateACourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateACourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedCourse = action.payload;
      })
      .addCase(updateACourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(deleteACourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteACourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedCourse = action.payload;
      })
      .addCase(deleteACourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(resetState, () => initialState);
  },
});

export default courseSlice.reducer;
